import {
    Flex,
    Layout,
    theme,
} from 'antd';
import {
    CSSProperties,
    useMemo,
} from 'react';
import { Outlet } from 'react-router-dom';

import { useUIStore } from '@/stores';

const layoutStyle: CSSProperties = {
    minHeight: '100vh',
};

export const LoginPageLayout = () => {
    const { token } = theme.useToken();
    const { theme: currentTheme } = useUIStore();

    const backgroundImageStyle: CSSProperties = useMemo(() => ({
        backgroundColor: currentTheme === 'light'
            ? token.colorFill
            : token.colorBgContainer,
    }), [currentTheme, token]);

    return (
        <Layout style={backgroundImageStyle}>
            <Layout.Content>
                <Flex vertical style={layoutStyle}>
                    <Outlet />
                </Flex>
            </Layout.Content>
        </Layout>
    );
};
